import { ListItem, ListItemIcon, ListItemText, makeStyles, Typography } from "@material-ui/core";
import _ from "lodash";
import React from "react";

const useStyles = makeStyles(() => ({
  presentationsContainer: {
    "& div:nth-child(odd)": {
      backgroundColor: "#F3F3F4"
    }
  },
  singleRow: {
    padding: 20,
    borderRadius: 8
  },
  presentationTitle: {
    color: "#000000",
    fontWeight: 700
  },
  presentationSubtitle: {
    color: "#565656",
    fontSize: "0.8rem",
    marginBottom: 10
  },
  presentationBody: {
    color: "#565656",
    fontSize: "0.8rem",
    wordWrap: "break-word",
    textOverflow: "clip",
    lineHeight: "1.3em",
    maxHeight: "3.9em",
    overflow: "hidden"
  }
}));

const PresentationsList = ({ presentations }) => {
  const classes = useStyles();

  return (
    <ListItem>
      <ListItemIcon />
      <ListItemText
        primary={
          <>
            <div className={classes.presentationsContainer}>
              {_.sortBy(presentations, ["position"]).map(present => (
                <div className={classes.singleRow} key={present.id}>
                  <Typography variant="h5" className={classes.presentationTitle}>
                    {present.title}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.presentationSubtitle}>
                    {present.subtitle}
                  </Typography>
                  <Typography variant="body2" className={classes.presentationBody}>
                    {present.body}
                  </Typography>
                </div>
              ))}
            </div>
          </>
        }
      />
    </ListItem>
  );
};

export default PresentationsList;
